// 本文件为全局单例

// 直接定义变量，无需使用自运行闭包函数实现
/** @type {HTMLAudioElement} */
let audio = null
export function getAudio() {
  if (audio === null) {
    audio = document.createElement('audio')
    audio.autoplay = true
    audio.preload = 'auto'
  }
  return audio
}

let navigatorTabBlinkInterval = null

let orginTitle = ''

const blankText = '【\u3000\u3000】'

export function stopTabBlink() {
  if (navigatorTabBlinkInterval !== null) {
    clearInterval(navigatorTabBlinkInterval)
  }
  navigatorTabBlinkInterval = null
  document.title = orginTitle
}

export function startTabBlink(text, speed = 1500) {
  let counter = 0

  orginTitle = document.title
  stopTabBlink()

  const msgText = `【${text}】`

  navigatorTabBlinkInterval = setInterval(() => {
    counter = (counter + 1) % 3
    document.title = counter === 2 ? blankText : msgText
  }, speed)
}
